var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[(_vm.showBackFn())?_c('img',{staticClass:"backIcon",attrs:{"src":require("@/assets/screen-pic11.png"),"alt":""},on:{"click":function($event){return _vm.toBack()}}}):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n            爱心超市智能下单机\n        ")])]),_vm._v(" "),_c('router-view',{staticStyle:{"padding-top":"160px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5882e2f3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 